export function openTownApp(movelink: string) {
  const isDev = process.env.isProdServer === 'false';
  const appScheme = `town://${movelink}`; // 실제 앱 스킴
  const playStoreUrl = 'https://play.google.com/store/apps/details?id=kr.co.proptier.town'; // 안드로이드 스토어 URL
  const appStoreUrl = 'https://apps.apple.com/kr/app/id6736497502'; // iOS 스토어 URL

  const userAgent = navigator.userAgent.toLowerCase();
  const isAndroid = userAgent.indexOf('android') > -1;
  const isIOS = /iphone|ipad|ipod/.test(userAgent);

  const redirectToApp = () => {
    if (isAndroid) {
      const intentUrl = `intent://${movelink}#Intent;scheme=town;package=kr.co.proptier.town;S.browser_fallback_url=${playStoreUrl};end;`;
      window.location.href = isDev ? appScheme : intentUrl;
    } else if (isIOS) {
      setTimeout(() => {
        window.location.href = appScheme;
      }, 0);
    }
  };

  const redirectToStore = () => {
    if (isAndroid && !isDev) {
      // 개발 환경이 아니면 Android는 앱 스토어로 리다이렉트하지 않음
      return;
    }

    const storeUrl = isAndroid ? playStoreUrl : isIOS ? appStoreUrl : null;
    if (storeUrl) {
      window.location.href = storeUrl;
    }
  };

  // 타임아웃 시간 설정 (ms)
  const timeout = 3000;
  // 현재 시간 저장
  const startTime = new Date().getTime();

  redirectToApp();

  setTimeout(() => {
    if (Date.now() - startTime < timeout + 100) {
      redirectToStore();
    }
  }, timeout);
}
